// Dependencies
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from 'reportWebVitals';

// MSAL
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from 'configs/authConfig';

// Components
import App from 'App';

// Styles
import 'styles/index.css';

// TODO: setup fake backend; comment out when using real services
// import { configureFakeBackend } from 'utils/fakeBackend';
// configureFakeBackend();

/**
 * MSAL should be instantiated outside of the component tree to prevent it from being re-instantiated on re-renders. 
 * For more, visit: https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-react/docs/getting-started.md
 */
export const msalContext = App.msalContext;
export const msalInstance = new PublicClientApplication(msalConfig);
const accounts = msalInstance.getAllAccounts();

if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
        const account = event.payload.account;
        msalInstance.setActiveAccount(account);

        // this is the state we initially sent to azure before sign in; azure sends it back after sign in
        const state = event.payload.state;
        if (state) {
            sessionStorage.setItem('msalState', state);
        }
    }

    if (event.eventType === EventType.LOGIN_FAILURE) {
        console.log(JSON.stringify(event));
    }
});

ReactDOM
    .createRoot(document.getElementById('root') || document.createElement('div')) // allows unit tests to easily work
    .render(
        <React.StrictMode>
            <App instance={msalInstance} />
        </React.StrictMode>
    );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
